import React from "react";
import useComponents from "~/hooks/useAllComponents";
import { Badge } from "@caesars-ui/core";
import { Link } from "gatsby";
import { Icon } from "@caesars-ui/core";
import kebabCase from "lodash/kebabCase";
import startCase from "lodash/startCase";
import masterChangelog from "changelog";

const { byComponent } = masterChangelog;

const changelogComponentNames = Object.keys(byComponent).map(name => name.toLowerCase());

const ListItem = ({ children }) => (
  <li className="text-size-3 list-none mr-3 pr-3 last:border-0 border-r-1 border-solid border-fg-minimal">
    {children}
  </li>
);
const PlatformLabel = ({ children }) => (
  <span className="mr-3">{children}</span>
);
export const ComponentStatusBar = ({ of = "" }) => {

  const asSlug = kebabCase(of.toLowerCase());
  const asComponentName = startCase(of).replace(" ", "").toLowerCase();
  const component =
    useComponents()
      .allAirtableComponents.edges.map((e) => e.node.data)
      .filter(
        (d) =>
          d.Type === "Component" && d.Slug.toLowerCase() === asSlug
      )[0] || null;
  if (!component) return null;
  
  console.log('Available fields:', Object.keys(component).sort());
  console.log('Package field value:', component.Package);
  
  return (
    <div className="my-4 flex justify-between items-center">
      <ul className="list-none flex items-start text-size-3 font-bold">
        <ListItem>
          <PlatformLabel>Figma:</PlatformLabel>
          {!component.Figma_Library ? "--" : <Badge status={component.Figma_Library === "Ready" ? "positive" : component.Figma_Library === "Planned" ? "info" : undefined} type={component.Figma_Library === "Partially Ready" ? "subtle" : undefined} text={component.Figma_Library} size="sm" />}
        </ListItem>
        <ListItem>
          <PlatformLabel>Web:</PlatformLabel>
          {!component.Web ? "--" : <Badge status={component.Web === "Ready" ? "positive" : component.Web === "Planned" ? "info" : undefined} type={component.Web === "Partially Ready" ? "subtle" : undefined} text={component.Web} size="sm" />}
        </ListItem>
        <ListItem>
          <PlatformLabel>iOS:</PlatformLabel>
          {!component.iOS ? "--" : <Badge status={component.iOS === "Ready" ? "positive" : component.iOS === "Planned" ? "info" : undefined} type={component.iOS === "Partially Ready" ? "subtle" : undefined} text={component.iOS} size="sm" />}
        </ListItem>
        {component.Package && (
          <ListItem>
            <PlatformLabel>Package:</PlatformLabel>
            <Badge text={component.Package} size="sm" type="subtle" status="info" />
          </ListItem>
        )}
      </ul>
      {/* { changelogComponentNames.includes(asComponentName) ? <Link to="changelog" className="flex items-center">
        <Icon name="icon_ui_bullet-list" />
        <span className="pl-2 body-lg text-fg-moderate">Changelog</span>
      </Link> : null} */}
    </div>
  );
};

export default ComponentStatusBar;
